import axios from "axios";
import { store as storeNotification } from "react-notifications-component";
import {
	OFFICE_SAVED,
	OFFICE_SAVING,
	OFFICE_SAVING_FAILED,
	OFFICE_SAVING_INITIALIZE
} from "./types";

export const officeUpdate = (listdata) => async (dispatch) => {
	await dispatch({ type: OFFICE_SAVING });
	await storeNotification.addNotification({
		title: "updating",
		message: "System is Upadating Office...",
		type: "success",
		insert: "top",
		container: "top-right",
		animationIn: ["animated", "fadeIn"],
		animationOut: ["animated", "fadeOut"],
		dismiss: {
			duration: 5000,
			onScreen: true,
		},
	});

	console.log("company Submit data=", listdata);

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	await axios
		.post(listdata.url, listdata.data, config)
		.then((response) => {
			dispatch({ type: OFFICE_SAVED, payload: response });
			storeNotification.addNotification({
				title: "Updating!",
				message: "Succefull updated Office",
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});

			console.log("response.data=", response.data);
		})
		.catch((error) => {
			console.log(error);
			storeNotification.addNotification({
				title: "Updating!",
				message: "failed to Update Office, check if name of the office exists",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return dispatch({
				type: OFFICE_SAVING_FAILED,
				payload: error,
			});
		});
};

export const officeSaveInitialize = (listdata) => (dispatch) => {
	dispatch({ type: OFFICE_SAVING_INITIALIZE });
};
